document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-side-drawer-id]').forEach(function (wrapper) {
    var trigger = wrapper.querySelector('[data-side-drawer-trigger]');
    var panel = wrapper.querySelector('[data-side-drawer-panel]');
    var overlay = wrapper.querySelector('[data-side-drawer-overlay]');
    var closeBtn = wrapper.querySelector('[data-side-drawer-close]');

    if (!trigger || !panel || !overlay) return;

    function openDrawer() {
      panel.classList.add('is-open');
      overlay.classList.add('is-visible');
      overlay.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      panel.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () {
        if (!panel.classList.contains('is-open')) {
          overlay.hidden = true;
        }
      }, 300);
    }

    trigger.addEventListener('click', function () {
      var isOpen = panel.classList.contains('is-open');
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  });
});
